import React, { useEffect, useState } from "react";
import moment from "moment";
import { PlusCircleFilled } from "@ant-design/icons";
import { find, forEach, get, head, isEmpty , cloneDeep , set } from "lodash";
import { Button, Tooltip } from "antd";

import { CareManagementCanEdit } from "@components/accessLevel/careManagementCanEdit";
import Icon from "@assets/icon_config";
import { getClientName } from "@utils/helpers";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import CareCoordinationService from "@services/care-coordination";
import { dateFormatConfig } from "@utils/constants";
import "./history.scss";
import { mapRules } from "@pages/member-details/care-coordination/helpers";

const History = (props: any) => {
  const {prvBtn , setPrvBtn , nxtBtn , setNxtBtn , activeCopyTask} = props;
  // const activeCopyTask = props.activeCopyTask;
  const subTaskLastUpdatedDate = props.subTaskLastUpdatedDate;
  const [taskHistoryTimeStamp, setTaskHistoryTimeStamp] = useState<any>(moment.utc());
  // const [prvBtn, setPrvBtn] = useState(false);
  // const [nxtBtn, setNxtBtn] = useState(true);
  let clientName = getClientName();
  const taskHistoryTimeFormat = dateFormatConfig.get(clientName)["defaultDateFormatWithTime"];

  const setProgramsData = useCareCoordinationStore((state) => state.setDataForCareCoordination);
  const rules = cloneDeep(useCareCoordinationStore((state) => state.rules));
  useEffect(() => {
    if (props.disableUpdate() && !props.isUserOnHistory) {
      getSubtaskHistory("prev", true);
    }
  }, []);


  //function to check if all the subtask has isLastRecordFound true 
  const isLastRecordFoundCheck = (arr : any) => {
    return arr.every((item : any) => item.isLastRecordFound === true)
  }

  //Get subTaskHitory for current task
  const getSubtaskHistory = async (flag: any, isDataLoadFromUseEffect?: boolean) => {
    props.setSpinner(true);
    await CareCoordinationService.fetchSubTaskHistory({ taskId: props.taskId, date: taskHistoryTimeStamp, flag: flag }).subscribe({
      next: async (v) => {
        if (!v.data.data) {
          // notification.info({
          //   message: "Task History",
          //   description: `${props.taskDescription} does not have any ${flag === "prev" ? "previous" : "next"} history`,
          //   onClick: () => {
          //     console.log("Notification Clicked!");
          //   },
          // });

          /* initially :
          if data is null
            next and prev both disabled
            
          if data is not null
            next is disabled prev is enabled
            
      on click of prev :
          if next is disabled it should be enabled
          if isLastRecordFound is true prev should be disbled
          else prev should be enabled
          
      on click of next :
          if prev is disabled it should be enabled
          if isLastRecordFound is true next should be disbled
          else next should be enabled  */

          if (flag === "prev") {
            setPrvBtn(true);
            if (isDataLoadFromUseEffect) {
              setNxtBtn(true);
            } else {
              setNxtBtn(false);
            }
          } else {
            setNxtBtn(true);
            setPrvBtn(false);
          }
        } else {
          if (isDataLoadFromUseEffect) {
            activeCopyTask.subtasks.forEach((s : any) => {
              set(s , 'lastSubtaskUpdatedDate' ,get(head(v.data.data), "lastSubtaskUpdatedDate"))
            })
            setNxtBtn(true);
            setPrvBtn(false);
          } else {
            if(flag === "prev"){
              if(nxtBtn){
                setNxtBtn(false);
              }
              if(isLastRecordFoundCheck(v.data.data)) {
                setPrvBtn(true);
              } else {
                setPrvBtn(false);
              }
            } else {
              if(prvBtn){
                setPrvBtn(false);
              }
              if(isLastRecordFoundCheck(v.data.data)) {
                setNxtBtn(true);
              } else {
                setNxtBtn(false);
              }
            }
          }
          let dependantItems: any = [];

          forEach(props.activeTask.subtasks, (task) => {
            task.value = find(v.data.data, { id: task?.id?.toString() })?.value ? find(v.data.data, { id: task?.id?.toString() })?.value : find(v.data.data, { id: task?.id })?.value;

            let dependents: any[] = [];

            const rule: any = [];
            forEach(task?.ruleName, (item: any) => {
              const temp_rule = find(props.rules, { ruleName: item?.name });
              rule.push(temp_rule);
            });

            forEach(task?.ruleName, (item: any) => {
              forEach(item?.children, (deps_tasks: any) => {
                if(get(find(rules , {ruleName : get(item , 'name')}) ,'properties[0].property') === 'display'){
                  dependents.push({
                    id: parseInt(deps_tasks),
                    display: false,
                  });
                }
              });
            });

            mapRules(rule, task, dependents , props.activeTask);
            dependantItems = [...dependantItems, ...dependents];
          });

          setProgramsData(props.programsData);
          props.setDependantSubTasks(dependantItems);

          setTaskHistoryTimeStamp(get(head(v.data.data), "lastSubtaskUpdatedDate", moment.utc()));
        }
        props.setIsUserOnHistory(true);
        // setTaskHistoryData(v.data.data);
        props.setSpinner(false);
      },
      error: (e: any) => {
        props.setSpinner(false);
        console.log(e);
      },
    });
  };

  //Move to latest task state
  const moveToLatestRecord = () => {
    // console.log("latest task state");
    // activeTask.subtasks = activeCopyTask.subtasks;

    let dependantItems: any = [];

    forEach(props.activeTask.subtasks, (task) => {
      let dependents: any[] = [];
      task.value =
        find(activeCopyTask.subtasks, { id: task?.id })?.isDisplayHistory === "N"
          ? null
          : find(activeCopyTask.subtasks, { id: task?.id })?.value
          ? find(activeCopyTask.subtasks, { id: task?.id })?.value
          : find(activeCopyTask.subtasks, { id: task?.id })?.value;

      const rule: any = [];
      forEach(task?.ruleName, (item: any) => {
        const temp_rule = find(props?.rules, { ruleName: item?.name });
        rule.push(temp_rule);
      });

      forEach(task?.ruleName, (item: any) => {
        forEach(item?.children, (deps_tasks: any) => {
          if(get(find(rules , {ruleName : get(item , 'name')}) ,'properties[0].property') === 'display'){
            dependents.push({
              id: parseInt(deps_tasks),
              display: false,
              parent : task.id,
              rule : item.name
            });
          }
        });
      });

      mapRules(rule, task, dependents , props.activeTask);

      dependantItems = [...dependantItems, ...dependents];
    });

    setProgramsData(props.programsData);
    props.setDependantSubTasks(dependantItems);
    props.setIsUserOnHistory(false);
    setTaskHistoryTimeStamp(get(head(activeCopyTask.subtasks), "lastSubtaskUpdatedDate", moment.utc()));
    setPrvBtn(false);
    setNxtBtn(true);
    // setTaskHistoryData(props.activeTask.subtasks);
  };

  return (
    <div className="ui-program-intervention-task-sub-tasks__body__task">
      <div className="ui-program-intervention-task-sub-tasks__body__task__header history">
        {/* Description of the task */}

        <div className="ui-program-intervention-task-sub-tasks__body__task__header__description task-history">
          <span className="task-history__value">
            {`${props.taskDescription} - Task Details`}
            {props.disableUpdate() && !props.isUserOnHistory && moment(subTaskLastUpdatedDate).isValid() && !isEmpty(subTaskLastUpdatedDate) ? (
              <span className="ui-program-intervention-task-sub-tasks__body__task__header__description__task-last-updated">{`( As on ${subTaskLastUpdatedDate?.format(taskHistoryTimeFormat)} )`}</span>
            ) : null}
          </span>
        </div>
        <div className="ui-program-intervention-task-sub-tasks__body__task__header__value-history">
          <div className="ui-program-intervention-task-sub-tasks__body__task__header__value-history__arrow">
            <Button
              type="text"
              shape="circle"
              icon={<i className="icon icon-chevron-left" />}
              size={"middle"}
              className={`profile-img-btn ${prvBtn || !props.isUserOnHistory ? "profile-img-btn--disabled" : ""}`}
              disabled={prvBtn || !props.isUserOnHistory}
              onClick={() => {
                getSubtaskHistory("prev");
              }}
            />
          </div>
          <div className="ui-program-intervention-task-sub-tasks__body__task__header__value-history__date">
            <div className="ui-program-intervention-task-sub-tasks__body__task__header__value-history__date__calender-icon">
              <Icon name="calender" />
            </div>
            <div className="ui-program-intervention-task-sub-tasks__body__task__header__value-history__date__label">{`Task Date: `}</div>
            <div className="ui-program-intervention-task-sub-tasks__body__task__header__value-history__date__value">
              {props.isUserOnHistory ? moment.utc(taskHistoryTimeStamp).local().format(taskHistoryTimeFormat) : moment().format(taskHistoryTimeFormat)}
            </div>
          </div>
          <div className="ui-program-intervention-task-sub-tasks__body__task__header__value-history__arrow subTask-right-arrow">
            <Button
              type="text"
              shape="circle"
              icon={<i className="icon icon-chevron-right" />}
              size={"middle"}
              className={`profile-img-btn ${nxtBtn || !props.isUserOnHistory ? "profile-img-btn--disabled" : ""}`}
              disabled={nxtBtn || !props.isUserOnHistory}
              onClick={() => {
                getSubtaskHistory("next");
              }}
            />
          </div>
          {!props?.disableNewInstance ? (
            <CareManagementCanEdit edit={props?.canEdit} hide={false}>
              <Tooltip placement="top" title={"Add new instance"}>
                <div className="ui-program-intervention-task-sub-tasks__body__task__header__value-history__arrow DoubleArrowRight" onClick={() => moveToLatestRecord()}>
                  <PlusCircleFilled style={{ fontSize: "32px", color: "#0072e3" }} />
                </div>
              </Tooltip>
            </CareManagementCanEdit>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default History;
